import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    globalSearchItems: [],
    countries: [],
    currencies:[],
    cities: [],
    widgetHash: "",
    hasListenerMessagesFromIframe: false,
    isLoadingSearch: false,
    isLoadingCurrencies: false,
    brands: [
      {
        name: "Abarth",
        code: "1",
        catalog_code: "1",
        logo: "https://img.levam.net/images/logos/big/abarth.png",
        logo_small: "https://img.levam.net/images/logos/small/abarth.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "ZFA22300005198590",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Alfa Romeo",
        code: "2",
        catalog_code: "2",
        logo: "https://img.levam.net/images/logos/big/alfa-romeo.png",
        logo_small: "https://img.levam.net/images/logos/small/alfa-romeo.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "ZFA22300005198590",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Audi",
        code: "3",
        catalog_code: "3",
        logo: "https://img.levam.net/images/logos/big/audi.png",
        logo_small: "https://img.levam.net/images/logos/small/audi.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WAUBA24B3XN104537",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "BMW",
        code: "70",
        catalog_code: "70",
        logo: "https://img.levam.net/images/logos/big/bmw.png",
        logo_small: "https://img.levam.net/images/logos/small/bmw.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WBSCK9345YLC91434",
        universal_classifier: "yes",
        type_moto: "yes",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Buick",
        code: "40",
        catalog_code: "40",
        logo: "https://img.levam.net/images/logos/big/buick.png",
        logo_small: "https://img.levam.net/images/logos/small/buick.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Cadillac",
        code: "34",
        catalog_code: "34",
        logo: "https://img.levam.net/images/logos/big/cadillac.png",
        logo_small: "https://img.levam.net/images/logos/small/cadillac.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Chevrolet",
        code: "32",
        catalog_code: "32",
        logo: "https://img.levam.net/images/logos/big/chevrolet.png",
        logo_small: "https://img.levam.net/images/logos/small/chevrolet.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "Citroen",
        code: "59",
        catalog_code: "59",
        logo: "https://img.levam.net/images/logos/big/citroen.png",
        logo_small: "https://img.levam.net/images/logos/big/citroen.png",
        supportframesearch: "no",
        frameexample: " ",
        supportvinsearch: "no",
        vinexample: " ",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Dacia",
        code: "62",
        catalog_code: "62",
        logo: "https://img.levam.net/images/logos/big/dacia.png",
        logo_small: "https://img.levam.net/images/logos/big/dacia.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "no",
        vinexample: "",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Datsun",
        code: "25",
        catalog_code: "25",
        logo: "https://img.levam.net/images/logos/big/datsun.png",
        logo_small: "https://img.levam.net/images/logos/small/datsun.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "JN1TANZ50U0013505",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Fiat",
        code: "5",
        catalog_code: "5",
        logo: "https://img.levam.net/images/logos/big/fiat.png",
        logo_small: "https://img.levam.net/images/logos/small/fiat.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "ZFA22300005198590",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "Ford",
        code: "21",
        catalog_code: "21",
        logo: "https://img.levam.net/images/logos/big/ford.png",
        logo_small: "https://img.levam.net/images/logos/small/ford.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1FA6P8CF0F5389504",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "GMC",
        code: "50",
        catalog_code: "50",
        logo: "https://img.levam.net/images/logos/big/gmc.png",
        logo_small: "https://img.levam.net/images/logos/small/gmc.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Honda",
        code: "22",
        catalog_code: "22",
        logo: "https://img.levam.net/images/logos/big/honda.png",
        logo_small: "https://img.levam.net/images/logos/small/honda.png",
        supportframesearch: "yes",
        frameexample: "JHMASY3330C",
        supportvinsearch: "yes",
        vinexample: "7A3EK1630SN000001",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "Hummer",
        code: "46",
        catalog_code: "46",
        logo: "https://img.levam.net/images/logos/big/hummer.png",
        logo_small: "https://img.levam.net/images/logos/small/hummer.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Hyundai",
        code: "27",
        catalog_code: "27",
        logo: "https://img.levam.net/images/logos/big/hyundai.png",
        logo_small: "https://img.levam.net/images/logos/small/hyundai.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "KMHFG4DG0CA072668",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "Infiniti",
        code: "7",
        catalog_code: "7",
        logo: "https://img.levam.net/images/logos/big/infiniti.png",
        logo_small: "https://img.levam.net/images/logos/small/infiniti.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "JN1TANZ50U0013505",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Kia",
        code: "28",
        catalog_code: "28",
        logo: "https://img.levam.net/images/logos/big/kia.png",
        logo_small: "https://img.levam.net/images/logos/small/kia.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "KNAJP811MF7048198",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "Lancia",
        code: "9",
        catalog_code: "9",
        logo: "https://img.levam.net/images/logos/big/lancia.png",
        logo_small: "https://img.levam.net/images/logos/small/lancia.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "ZFA22300005198590",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Lexus",
        code: "10",
        catalog_code: "10",
        logo: "https://img.levam.net/images/logos/big/lexus.png",
        logo_small: "https://img.levam.net/images/logos/small/lexus.png",
        supportframesearch: "yes",
        frameexample: "ACA20-0001035",
        supportvinsearch: "yes",
        vinexample: "JT4RN56S2F0139246",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Maybach",
        code: "31",
        catalog_code: "31",
        logo: "https://img.levam.net/images/logos/big/maybach.png",
        logo_small: "https://img.levam.net/images/logos/small/maybach.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WDB2093652F024974",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Mazda",
        code: "58",
        catalog_code: "58",
        logo: "https://img.levam.net/images/logos/big/mazda.png",
        logo_small: "https://img.levam.net/images/logos/small/mazda.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "MM7UNY08230314954",
        universal_classifier: "no",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Mercedes",
        code: "29",
        catalog_code: "29",
        logo: "https://img.levam.net/images/logos/big/merce.png",
        logo_small: "https://img.levam.net/images/logos/small/merce.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WDB2093652F024974",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "Mini",
        code: "71",
        catalog_code: "71",
        logo: "https://img.levam.net/images/logos/big/mini.png",
        logo_small: "https://img.levam.net/images/logos/small/mini.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WBSCK9345YLC91434",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Nissan",
        code: "14",
        catalog_code: "14",
        logo: "https://img.levam.net/images/logos/big/nissan.png",
        logo_small: "https://img.levam.net/images/logos/small/nissan.png",
        supportframesearch: "yes",
        frameexample: "R11-202091",
        supportvinsearch: "yes",
        vinexample: "JN1TANZ50U0013505",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Oldsmobile",
        code: "39",
        catalog_code: "39",
        logo: "https://img.levam.net/images/logos/big/oldsmobile.png",
        logo_small: "https://img.levam.net/images/logos/small/oldsmobile.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Opel",
        code: "33",
        catalog_code: "33",
        logo: "https://img.levam.net/images/logos/big/opel.png",
        logo_small: "https://img.levam.net/images/logos/small/opel.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Peugeot",
        code: "60",
        catalog_code: "60",
        logo: "https://img.levam.net/images/logos/big/peugeot.png",
        logo_small: "https://img.levam.net/images/logos/big/peugeot.png",
        supportframesearch: "no",
        frameexample: " ",
        supportvinsearch: "no",
        vinexample: " ",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Pontiac",
        code: "35",
        catalog_code: "35",
        logo: "https://img.levam.net/images/logos/big/pontiac.png",
        logo_small: "https://img.levam.net/images/logos/small/pontiac.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Renault",
        code: "63",
        catalog_code: "63",
        logo: "https://img.levam.net/images/logos/big/renault.png",
        logo_small: "https://img.levam.net/images/logos/big/renault.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "no",
        vinexample: "",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Rolls-Royce",
        code: "72",
        catalog_code: "72",
        logo: "https://img.levam.net/images/logos/big/rolls_royce.png",
        logo_small: "https://img.levam.net/images/logos/small/rolls_royce.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WBSCK9345YLC91434",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Saab",
        code: "47",
        catalog_code: "47",
        logo: "https://img.levam.net/images/logos/big/saab.png",
        logo_small: "https://img.levam.net/images/logos/small/saab.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Saturn",
        code: "48",
        catalog_code: "48",
        logo: "https://img.levam.net/images/logos/big/saturn.png",
        logo_small: "https://img.levam.net/images/logos/small/saturn.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Seat",
        code: "16",
        catalog_code: "16",
        logo: "https://img.levam.net/images/logos/big/seat.png",
        logo_small: "https://img.levam.net/images/logos/small/seat.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WAUBA24B3XN104537",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Skoda",
        code: "17",
        catalog_code: "17",
        logo: "https://img.levam.net/images/logos/big/skoda.png",
        logo_small: "https://img.levam.net/images/logos/small/skoda.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WAUBA24B3XN104537",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Smart",
        code: "30",
        catalog_code: "30",
        logo: "https://img.levam.net/images/logos/big/smart.png",
        logo_small: "https://img.levam.net/images/logos/small/smart.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WDB2093652F024974",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "SsangYong",
        code: "65",
        catalog_code: "65",
        logo: "https://img.levam.net/images/logos/big/ssangyong.png",
        logo_small: "https://img.levam.net/images/logos/big/ssangyong.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "no",
        vinexample: "KPBKJ2AE1GP107523",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Subaru",
        code: "26",
        catalog_code: "26",
        logo: "https://img.levam.net/images/logos/big/subaru.png",
        logo_small: "https://img.levam.net/images/logos/small/subaru.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "JF2SJGK85DG003373",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Suzuki",
        code: "49",
        catalog_code: "49",
        logo: "https://img.levam.net/images/logos/big/suzuki.png",
        logo_small: "https://img.levam.net/images/logos/small/suzuki.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "1G1F91R61H0119208",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Toyota",
        code: "19",
        catalog_code: "19",
        logo: "https://img.levam.net/images/logos/big/toyota.png",
        logo_small: "https://img.levam.net/images/logos/small/toyota.png",
        supportframesearch: "yes",
        frameexample: "ACA20-0001035",
        supportvinsearch: "yes",
        vinexample: "JT4RN56S2F0139246",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Vauxhall",
        code: "24",
        catalog_code: "24",
        logo: "https://img.levam.net/images/logos/big/vauxhall.png",
        logo_small: "https://img.levam.net/images/logos/small/vauxhall.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "W0L0XCF0814000002",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "yes",
      },
      {
        name: "Volkswagen",
        code: "20",
        catalog_code: "20",
        logo: "https://img.levam.net/images/logos/big/vw.png",
        logo_small: "https://img.levam.net/images/logos/small/vw.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "yes",
        vinexample: "WAUBA24B3XN104537",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Volvo",
        code: "64",
        catalog_code: "64",
        logo: "https://img.levam.net/images/logos/big/volvo.png",
        logo_small: "https://img.levam.net/images/logos/big/volvo.png",
        supportframesearch: "no",
        frameexample: "",
        supportvinsearch: "no",
        vinexample: "",
        universal_classifier: "yes",
        type_moto: "no",
        type_auto: "yes",
        type_transport: "no",
      },
      {
        name: "Zinoro",
        code: "73",
        catalog_code: "73",
        logo: "https://img.levam.net/images/logos/big/zinoro.png",
        logo_small: "https://img.levam.net/images/logos/small/zinoro.png",
      },
    ],
    popularBrands: [
      "ALFA ROMEO",
      "AUDI",
      "BMW",
      "CADILLAC",
      "CHEVROLET",
      "CHRYSLER",
      "CITROEN",
      "DAEWOO",
      "DODGE",
      "FIAT",
      "FORD",
      "GREAT WALL",
      "HONDA",
      "HUMMER",
      "HYUNDAI",
      "INFINITI",
      "JAGUAR",
      "JEEP",
      "KIA",
      "LADA",
      "LAND ROVER",
      "LEXUS",
      "MAZDA",
      "MERCEDES-BENZ",
      "MITSUBISHI",
      "NISSAN",
      "OPEL",
      "PEUGEOT",
      "PORSCHE",
      "RENAULT",
      "SAAB",
      "SEAT",
      "SKODA",
      "SSANGYONG",
      "SUBARU",
      "SUZUKI",
      "TOYOTA",
      "VOLVO",
      "VOLKSWAGEN",
    ],
    translations: null,
    locales: ['ru', 'en', 'es']
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    showError({ commit, state, dispatch }, payload) {
      let text;
      let error = payload.error;
      let is_alert = payload.is_alert;
      if (error.response) {
        if(error.response && error.response.status === 403){
          router.push({ name: 'login', query: { 'goto': 'back' }});
          this._vm.$error(this._vm.i18n.t('error.you_are_not_logged_in_or_your_session_has_expired'));
          return;
        }
        if (error.response.status != 200 && error.response.status != 422) {
          let errText =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : false;
          text =
            errText || error.response.status + " " + error.response.statusText;
        } else {
          text = Object.entries(error.response.data.errors)[0][1][0];
        }
      } else if (error.message) {
        text = error.message;
      } else {
        text = error;
      }
      if(is_alert){
        this._vm.$alert(text || "Unknown error");
      } else {
        this._vm.$error(text || "Unknown error");
      }
    },

    async getTranslations({ commit, state, dispatch }, payload) {

      return await axios
        .get(this._vm.$apiURL + "/i18n", {
          locale: payload
        })
        .then((response) => {
          updateField(state, { path: "translations", value: response.data.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async currenciesGet({ commit, state, dispatch }) {
      updateField(state, { path: "isLoadingCurrencies", value: true });
      return await axios
        .get(this._vm.$apiURL + "/currencies")
        .then((response) => {
          updateField(state, { path: "currencies", value: response.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
          .finally(()=>{
            updateField(state, { path: "isLoadingCurrencies", value: false });
          })
    },
    async countriesGet({ commit, state, dispatch }) {
      return await axios
        .get(this._vm.$apiURL + "/countries")
        .then((response) => {
          updateField(state, { path: "countries", value: response.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    citiesGet({ commit, state, dispatch }, payload) {
      updateField(state, { path: "cities", value: [] });
      axios
        .get(this._vm.$apiURL + "/countries/" + payload.id)
        .then((response) => {
          updateField(state, { path: "cities", value: response.data.cities });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    globalSearch({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isLoadingSearch", value: true });
      updateField(state, { path: "globalSearchItems", value: [] });
      axios
          .get(this._vm.$apiURL + "/search?find_string=" + payload)
          .then((response) => {
            updateField(state, { path: "globalSearchItems", value: response.data.data });
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(()=>{
            updateField(state, { path: "isLoadingSearch", value: false });
          })
    }
  },
};
